/**
 * Pantalla 3 (docs/FASE-1.md §6): catálogo de módulos. Solo lectura — la consola no ofrece un
 * editor de manifiesto (ver nota en `src/api/client.ts`, `modulesApi.upsert`).
 */
import type { Module } from "@continnua/contracts";
import { useEffect, useState, type ReactElement } from "react";
import { Link } from "react-router-dom";

import { modulesApi } from "../api/client";
import { Badge, toneForStatus } from "../components/Badge";
import { DataTable, type DataTableColumn } from "../components/DataTable";
import { toDisplayMessage } from "../lib/errors";

const STATUS_LABEL: Record<string, string> = { active: "Activo", hidden: "Oculto", retired: "Retirado" };

export function Modules(): ReactElement {
  const [items, setItems] = useState<Module[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    modulesApi
      .list()
      .then((page) => {
        if (!cancelled) setItems(page.items);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(toDisplayMessage(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const columns: DataTableColumn<Module>[] = [
    { key: "name", header: "Módulo", render: (m) => <Link to={`/modules/${m.code}`}>{m.name}</Link> },
    { key: "code", header: "Código", render: (m) => m.code },
    { key: "baseUrl", header: "URL base", render: (m) => m.baseUrl },
    { key: "status", header: "Estado", render: (m) => <Badge tone={toneForStatus(m.status)}>{STATUS_LABEL[m.status] ?? m.status}</Badge> },
    { key: "version", header: "Versión manifiesto", render: (m) => String(m.manifestVersion) },
  ];

  return (
    <section>
      <div className="page-header">
        <h1>Módulos</h1>
      </div>
      {error && (
        <p className="field-error" role="alert">
          {error}
        </p>
      )}
      <DataTable columns={columns} rows={items} rowKey={(m) => m.code} emptyMessage={loading ? "Cargando…" : "No hay módulos registrados."} />
    </section>
  );
}
